import React from 'react';
import { render } from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';

import { createStore } from 'redux';
import reducers from './reducers';
import { Provider } from 'react-redux';

import App from './containers/AppContainer';

const initialState = {
    organizationsList: [{}],
    organizationCode: new URLSearchParams(window.location.search).get("organization"),
    organizationSwitcher: new URLSearchParams(window.location.search).get("organization_switch") === 'enable',
    tSesSwitcher: new URLSearchParams(window.location.search).get("session_switch") === 'enable',
    schedule: [],
    days: 14,
    tSesList: [{
        "pers" : 'all',
        "title" : "Все",
        "description" : "Отображать все записи"
    }],
    tSes: 'all',
    rowTitlePosition: -1,
};
const store = createStore(reducers, initialState);

render(
    <Provider store={store}>
        <App />
    </Provider>
, document.getElementById('root'));

serviceWorker.unregister();
